"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOMER_CURRENCY_PATCH_RETRY_PAUSE_MS = exports.CUSTOMER_CURRENCY_PATCH_MAX_ATTEMPTS = exports.normalizeCurrencyInternalId = exports.createCustomerCurrencyEnsurer = exports.logErrorFull = exports.isNetSuiteHttpError = exports.truncateForLog = exports.summarizeNetSuiteResponseBody = exports.getNetSuiteErrorMessage = exports.extractNetSuiteErrorDetail = exports.buildNetSuiteHttpErrorMessage = exports.describeNetSuiteError = exports.mapS3ContentTypeToNetsuite = exports.mapNetSuiteToS3ContentType = exports.getInvoiceFormId = exports.mapDatesToSubscriptionTerm = exports.generateNetsuiteLink = exports.createNetSuiteUtils = exports.NetsuiteApiClient = exports.billingAccountAddressListIdsMatch = exports.billingAccountAddressTextMatches = exports.extractBillingAccountAddressFields = exports.normalizeAddressTextForCompare = void 0;
const netsuiteApiClient_1 = __importDefault(require("./netsuiteApiClient"));
exports.NetsuiteApiClient = netsuiteApiClient_1.default;
const netsuiteUtils_1 = require("./netsuiteUtils");
Object.defineProperty(exports, "createNetSuiteUtils", { enumerable: true, get: function () { return netsuiteUtils_1.createNetSuiteUtils; } });
const netsuiteLinkGenerator_1 = require("./netsuiteLinkGenerator");
Object.defineProperty(exports, "generateNetsuiteLink", { enumerable: true, get: function () { return netsuiteLinkGenerator_1.generateNetsuiteLink; } });
const netSuiteErrorFormat_1 = require("./netSuiteErrorFormat");
Object.defineProperty(exports, "buildNetSuiteHttpErrorMessage", { enumerable: true, get: function () { return netSuiteErrorFormat_1.buildNetSuiteHttpErrorMessage; } });
Object.defineProperty(exports, "describeNetSuiteError", { enumerable: true, get: function () { return netSuiteErrorFormat_1.describeNetSuiteError; } });
Object.defineProperty(exports, "extractNetSuiteErrorDetail", { enumerable: true, get: function () { return netSuiteErrorFormat_1.extractNetSuiteErrorDetail; } });
Object.defineProperty(exports, "getNetSuiteErrorMessage", { enumerable: true, get: function () { return netSuiteErrorFormat_1.getNetSuiteErrorMessage; } });
Object.defineProperty(exports, "summarizeNetSuiteResponseBody", { enumerable: true, get: function () { return netSuiteErrorFormat_1.summarizeNetSuiteResponseBody; } });
Object.defineProperty(exports, "truncateForLog", { enumerable: true, get: function () { return netSuiteErrorFormat_1.truncateForLog; } });
Object.defineProperty(exports, "isNetSuiteHttpError", { enumerable: true, get: function () { return netSuiteErrorFormat_1.isNetSuiteHttpError; } });
Object.defineProperty(exports, "logErrorFull", { enumerable: true, get: function () { return netSuiteErrorFormat_1.logErrorFull; } });
const billingAccountAddressUtils_1 = require("./billingAccountAddressUtils");
Object.defineProperty(exports, "normalizeAddressTextForCompare", { enumerable: true, get: function () { return billingAccountAddressUtils_1.normalizeAddressTextForCompare; } });
Object.defineProperty(exports, "extractBillingAccountAddressFields", { enumerable: true, get: function () { return billingAccountAddressUtils_1.extractBillingAccountAddressFields; } });
Object.defineProperty(exports, "billingAccountAddressTextMatches", { enumerable: true, get: function () { return billingAccountAddressUtils_1.billingAccountAddressTextMatches; } });
Object.defineProperty(exports, "billingAccountAddressListIdsMatch", { enumerable: true, get: function () { return billingAccountAddressUtils_1.billingAccountAddressListIdsMatch; } });
const customerCurrency_1 = require("./customerCurrency");
Object.defineProperty(exports, "createCustomerCurrencyEnsurer", { enumerable: true, get: function () { return customerCurrency_1.createCustomerCurrencyEnsurer; } });
Object.defineProperty(exports, "normalizeCurrencyInternalId", { enumerable: true, get: function () { return customerCurrency_1.normalizeCurrencyInternalId; } });
Object.defineProperty(exports, "CUSTOMER_CURRENCY_PATCH_MAX_ATTEMPTS", { enumerable: true, get: function () { return customerCurrency_1.CUSTOMER_CURRENCY_PATCH_MAX_ATTEMPTS; } });
Object.defineProperty(exports, "CUSTOMER_CURRENCY_PATCH_RETRY_PAUSE_MS", { enumerable: true, get: function () { return customerCurrency_1.CUSTOMER_CURRENCY_PATCH_RETRY_PAUSE_MS; } });
const netsuite_1 = require("models/netsuite");
function mapDatesToSubscriptionTerm(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const yearDifference = end.getFullYear() - start.getFullYear();
    const isExactAnniversary = (start.getMonth() === end.getMonth() &&
        end.getDate() === start.getDate() - 1) ||
        (start.getMonth() === end.getMonth() + 1 &&
            end.getDate() === start.getDate()) ||
        (start.getMonth() === 11 &&
            end.getMonth() === 0 &&
            end.getDate() === start.getDate() - 1);
    if (isExactAnniversary) {
        switch (yearDifference) {
            case 1:
                return netsuite_1.SubscriptionTerm.ANNUAL_1_YEAR;
            case 2:
                return netsuite_1.SubscriptionTerm.ANNUAL_2_YEARS;
            case 3:
                return netsuite_1.SubscriptionTerm.ANNUAL_3_YEARS;
            case 4:
                return netsuite_1.SubscriptionTerm.ANNUAL_4_YEARS;
            case 5:
                return netsuite_1.SubscriptionTerm.ANNUAL_5_YEARS;
            case 6:
                return netsuite_1.SubscriptionTerm.ANNUAL_6_YEARS;
            case 10:
                return netsuite_1.SubscriptionTerm.ANNUAL_10_YEARS;
            default:
                return netsuite_1.SubscriptionTerm.CUSTOM_TERM;
        }
    }
    else {
        return netsuite_1.SubscriptionTerm.CUSTOM_TERM;
    }
}
exports.mapDatesToSubscriptionTerm = mapDatesToSubscriptionTerm;
const getInvoiceFormId = (subscriptionPlanId, countryGroup) => {
    if (subscriptionPlanId === "59472")
        // ESW 2020 Base Susbcription Plan
        return "176"; // ESW Invoice Suitebil... Renewals with Line - https://4914352-sb2.app.netsuite.com/app/accounting/transactions/custinvc.nl?cf=176
    if (countryGroup === "JAPAN")
        return "253"; // JAPAN ESW Suiteblling... V2 - https://4914352-sb2.app.netsuite.com/app/accounting/transactions/custinvc.nl?cf=253
    if (countryGroup === "INDIA")
        return "249"; // ESW Suitebilling Invoice with Subscription Plan "Tax Invoice - https://4914352-sb2.app.netsuite.com/app/accounting/transactions/custinvc.nl?cf=249
    return "243"; // ESW Suitebilling Inv...th Subscription Plan - https://4914352-sb2.app.netsuite.com/app/accounting/transactions/custinvc.nl?cf=243
};
exports.getInvoiceFormId = getInvoiceFormId;
// Define the NetSuite FileType to S3 ContentType mapping
const netsuiteToS3 = {
    APPCACHE: "text/cache-manifest",
    AUTOCAD: "application/vnd.autocad.dwg",
    BMPIMAGE: "image/bmp",
    CERTIFICATE: "application/x-x509-ca-cert",
    CONFIG: "application/xml",
    CSV: "text/csv",
    EXCEL: "application/vnd.ms-excel",
    FLASH: "application/x-shockwave-flash",
    FREEMARKER: "application/vnd.freemarker",
    GIFIMAGE: "image/gif",
    GZIP: "application/gzip",
    HTMLDOC: "text/html",
    ICON: "image/x-icon",
    JAVASCRIPT: "application/javascript",
    JPGIMAGE: "image/jpeg",
    JSON: "application/json",
    MESSAGERFC: "message/rfc822",
    MP3: "audio/mpeg",
    MPEGMOVIE: "video/mpeg",
    MSPROJECT: "application/vnd.ms-project",
    PDF: "application/pdf",
    PJPGIMAGE: "image/pjpeg",
    PLAINTEXT: "text/plain",
    PNGIMAGE: "image/png",
    POSTSCRIPT: "application/postscript",
    POWERPOINT: "application/vnd.ms-powerpoint",
    QUICKTIME: "video/quicktime",
    RTF: "application/rtf",
    SMS: "application/vnd.sms",
    STYLESHEET: "text/css",
    TAR: "application/x-tar",
    TIFFIMAGE: "image/tiff",
    VISIO: "application/vnd.visio",
    WEBAPPPAGE: "application/xhtml+xml",
    WORD: "application/msword",
    XMLDOC: "application/xml",
    XSD: "application/xml",
    ZIP: "application/zip",
    // Add other mappings as necessary
};
// Create the mapping function
function mapNetSuiteToS3ContentType(fileType) {
    return netsuiteToS3[fileType] || "application/octet-stream"; // Default to 'application/octet-stream' if no match is found
}
exports.mapNetSuiteToS3ContentType = mapNetSuiteToS3ContentType;
function mapS3ContentTypeToNetsuite(fileType) {
    return (Object.keys(netsuiteToS3).find((key) => netsuiteToS3[key] === fileType) ||
        "OTHER");
}
exports.mapS3ContentTypeToNetsuite = mapS3ContentTypeToNetsuite;
